import { createNgModule, Inject, Injectable } from '@angular/core';
import { DYNAMIC_COMPONENT, PLACEHOLDER_COMPONENTS, PLACEHOLDER_LAZY_COMPONENTS, } from './placeholder.token';
import { RawComponent } from '../components/raw.component';
import { isRawRendering } from '../components/rendering';
import * as i0 from "@angular/core";
export class JssComponentFactoryService {
    injector;
    components;
    lazyComponents;
    componentMap;
    lazyComponentMap;
    constructor(injector, components, lazyComponents) {
        this.injector = injector;
        this.components = components;
        this.lazyComponents = lazyComponents;
        this.componentMap = new Map();
        this.lazyComponentMap = new Map();
        this.components.forEach((c) => this.componentMap.set(c.name, c));
        if (this.lazyComponents) {
            this.lazyComponents.forEach((c) => this.lazyComponentMap.set(c.path, c));
        }
    }
    getComponent(component) {
        const loadedComponent = this.componentMap.get(component.componentName);
        if (loadedComponent) {
            return Promise.resolve({
                componentDefinition: component,
                componentImplementation: loadedComponent.type,
                canActivate: loadedComponent.canActivate,
                resolve: loadedComponent.resolve,
            });
        }
        const lazyComponent = this.lazyComponentMap.get(component.componentName);
        if (lazyComponent) {
            return lazyComponent.loadChildren().then((lazyChild) => {
                let componentType = null;
                const moduleRef = createNgModule(lazyChild, this.injector);
                const dynamicComponentType = moduleRef.injector.get(DYNAMIC_COMPONENT);
                if (!dynamicComponentType) {
                    throw new Error(`JssComponentFactoryService: Lazy load module for component "${lazyComponent.path}" missing DYNAMIC_COMPONENT provider. Missing JssModule.forChild()?`);
                }
                if (component.componentName in dynamicComponentType) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    componentType = dynamicComponentType[component.componentName];
                }
                else {
                    if (typeof dynamicComponentType === 'function') {
                        componentType = dynamicComponentType;
                    }
                    else {
                        throw new Error(`JssComponentFactoryService: Lazy load module for component "${lazyComponent.path}" missing DYNAMIC_COMPONENT provider. Missing JssModule.forChild()?`);
                    }
                }
                return {
                    componentDefinition: component,
                    componentImplementation: componentType,
                    componentModuleRef: moduleRef,
                    canActivate: lazyComponent.canActivate,
                    resolve: lazyComponent.resolve,
                };
            });
        }
        return Promise.resolve({
            componentDefinition: component,
        });
    }
    getComponents(components) {
        // acquire all components and keep them in order while handling their potential async-ness
        return Promise.all(components.map((component) => isRawRendering(component) ? this.getRawComponent(component) : this.getComponent(component)));
    }
    getRawComponent(component) {
        return Promise.resolve({
            componentImplementation: RawComponent,
            componentDefinition: component,
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: JssComponentFactoryService, deps: [{ token: i0.Injector }, { token: PLACEHOLDER_COMPONENTS }, { token: PLACEHOLDER_LAZY_COMPONENTS }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: JssComponentFactoryService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: JssComponentFactoryService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i0.Injector }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLACEHOLDER_COMPONENTS]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLACEHOLDER_LAZY_COMPONENTS]
                }] }] });
